/*
 * @Author: Yolo
 * @Date: 2024-07-01 16:29:54
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-01 16:30:36
 * @Desc 数据回显mock数据
 */
export const UserAreas = [
  {
    AreaID: '4AAA5919-DD25-414F-A9A5-23710542420A',
    UserName: 'yhtest',
    AreaName: '圆形数据',
    AreaType: 0,
    AreaShape: 2,
    Points: '12.000000,12.000000',
    Radius: 12,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgb(164, 59, 59,1)","fillColor":"rgb(164, 59, 59,1)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
  {
    AreaID: '8D0224A3-C821-4EDC-B2D1-6FAD48580C88',
    UserName: 'yhtest',
    AreaName: '多边形数据',
    AreaType: 0,
    AreaShape: 1,
    Points:
      '7.778320,14.360191,6.152344,13.656663,7.250977,12.479487,7.229004,13.197165,7.152100,13.517838,8.811035,13.806075,9.063721,13.229251,10.371094,14.083301,9.448242,14.445319,8.789063,14.796128,7.800293,15.135764,7.976074,14.785505',
    Radius: 0,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgba(255,0,0)","fillColor":"rgba(255,0,0)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
  {
    AreaID: 'C8EA55EA-EDA9-429B-95F9-F9CC8D91FE1A',
    UserName: 'yhtest',
    AreaName: '长方形或正方形',
    AreaType: 0,
    AreaShape: 0,
    Points:
      '8.344116,11.820604,8.344116,12.679614,11.200562,12.679614,11.200562,11.820604',
    Radius: 0,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgba(255,0,0)","fillColor":"rgba(255,0,0)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
]
export const UserMarkers = [
  {
    MarkerID: '1CEA8E33-CC55-4B79-A086-81027B756763',
    MarkerName: '12',
    MarkerType: 20,
    Lat: 12.033333,
    Lon: 12.033333,
    IsShow: 1,
  },
]
export const UserLines = [
  {
    LineID: '193AAB0D-C3B4-4622-9662-A0523B853A3D',
    LineName: 'hhh',
    Points:
      '11.9696044921875,12.077595751733533,11.827468872070312,11.982569230068208,11.742668151855469,11.998017521153082,11.682586669921875,11.983240913289094,11.620101928710938,11.976859855224403,11.658554077148438,11.878774151411488,11.77734375,11.854583194565883,11.825065612792969,11.927821437111179',
    IsShow: 1,
    Distance: 41.2,
    Style: '{"color":"","dashArray":[5,5],"weight":1,"lineTextColor":""}',
  },
]
